import {useTranslation} from 'react-i18next';

import {RatingBadge as RatingBadgeUi} from '@/components/RatingBadge';
import {REVIEW_SCORE_AMADEUS_MAX} from '@/consts';
import {mapAmadeusRatingToSentiment} from '@/modules/common/utils/rating';
import {testId} from '@/utils/testId';

type Props = {
  ratingScore: number;
  size?: 'small' | 'medium';
};

export const RatingBadge: React.FunctionComponent<Props> = ({
  ratingScore: ratingScoreProperty,
  size = 'medium',
}) => {
  const {t} = useTranslation('general');

  const ratingSentiment = mapAmadeusRatingToSentiment(ratingScoreProperty);
  const ratingScore = String(ratingScoreProperty.toFixed(1));
  const ratingScoreMax = REVIEW_SCORE_AMADEUS_MAX.toFixed(0);

  return (
    <RatingBadgeUi
      size={size}
      sentiment={ratingSentiment}
      data-testid={testId('hotel-rating')}
    >
      {t('ratingBadge.label', {ratingScore, ratingScoreMax})}
    </RatingBadgeUi>
  );
};
